import {
  FC,
  useState,
  useEffect,
  ReactNode,
  MutableRefObject,
  memo,
} from 'react';
import { Table } from 'antd';
import { getTotalInfo } from '../utils';
import { EditColumnType } from '../interface';
import { EditVirtualTableColumnType } from '../../EditVirtualTable/interface';
import { BaseTotalTableProps } from '../interface';
import { TABLE_COLUMN_EMPTY } from '../../constants/constant';
import './totalTable.less';

interface TotalTableAction {
  onChange: (tableData: any[]) => void;
}
export type TotalTableActionType = TotalTableAction | undefined;
interface TotalTableProps extends BaseTotalTableProps {
  /** 列配置 */
  columns: EditColumnType[] | EditVirtualTableColumnType[];
  /** 列表数据 */
  dataSource?: any[];
  /** 对象句柄 */
  actionRef: MutableRefObject<TotalTableActionType>;
}

const TotalTable: FC<TotalTableProps> = memo(props => {
  const {
    columns,
    dataSource,
    totalKeys,
    totalIndex,
    totalText,
    actionRef,
  } = props;
  const [totalData, setTotalData] = useState<any>({});
  useEffect(() => {
    const newTotalData = getTotalInfo(totalKeys, dataSource);
    setTotalData(newTotalData);
  }, [dataSource]);
  const handleChange = (tableData: any[]) => {
    const newTotalData = getTotalInfo(totalKeys, tableData);
    setTotalData(newTotalData);
  };
  const renderValue = (
    column: EditColumnType | EditVirtualTableColumnType,
  ): ReactNode => {
    const { dataIndex } = column;
    if (typeof dataIndex === 'string') {
      return totalData[dataIndex] !== undefined
        ? totalData[dataIndex]
        : TABLE_COLUMN_EMPTY;
    }
    return TABLE_COLUMN_EMPTY;
  };
  actionRef.current = {
    onChange: handleChange,
  };
  return (
    <Table.Summary.Row className="yb-editable-total-row">
      {columns.map((column, index) => {
        const { render, ellipsis, children, ...resColumnProps } = column;
        if (Array.isArray(children) && children.length) {
          return children.map((col, key) => {
            return (
              <Table.Summary.Cell index={index + key + 101} align={col.align} {...resColumnProps}>
                {renderValue(col)}
              </Table.Summary.Cell>
            );
          });
        }
        if (index === totalIndex) {
          return (
            <Table.Summary.Cell index={index} {...resColumnProps}>{totalText}</Table.Summary.Cell>
          );
        }
        return (
          <Table.Summary.Cell index={index} align={column.align} {...resColumnProps}>
            {renderValue(column)}
          </Table.Summary.Cell>
        );
      })}
    </Table.Summary.Row>
  );
});

TotalTable.defaultProps = {
  totalIndex: 0,
  totalText: '合计',
};

export default TotalTable;
